import api from "../api";

export const validationService = {
  getCredits: async (accountId, kpiCode = "prospection_credits") => {
    const res = await api.get("/api/payments/accounts/kpis/", {
      params: { account_id: accountId, code: kpiCode },
    });
    return res.data;
  },

  searchEmail: async ({
    accountId,
    firstName,
    lastName,
    domain,
    company = "",
    linkedinUrl = "",
  }) => {
    const res = await api.post("/api/validation/search/email/", {
      account_id: accountId,
      first_name: firstName,
      last_name: lastName,
      domain,
      company,
      linkedin_url: linkedinUrl,
    });
    return res.data;
  },

  searchLinkedin: async ({ accountId, linkedinUrl }) => {
    const res = await api.post("/api/validation/search/linkedin/", {
      account_id: accountId,
      linkedin_url: linkedinUrl,
    });
    return res.data;
  },

  searchBulk: async ({ accountId, file }) => {
    const form = new FormData();
    form.append("account_id", accountId);
    form.append("csv_file", file);
    const res = await api.post("/api/validation/search/bulk/", form, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return res.data;
  },

  listBulkTasks: async (accountId) => {
    const res = await api.get("/api/validation/search/bulk/list/", {
      params: { account_id: accountId },
    });
    return Array.isArray(res.data) ? res.data : [];
  },

  getBulkTask: async (taskId) => {
    const res = await api.get(`/api/validation/search/bulk/${taskId}/`);
    return res.data;
  },

  saveBulkResults: async (taskId, { accountId, rowIds }) => {
    const res = await api.post(`/api/validation/search/bulk/${taskId}/save/`, {
      account_id: accountId,
      row_ids: rowIds,
    });
    return res.data;
  },

  verifySingle: async ({ accountId, personId, email }) => {
    const res = await api.post("/api/validation/verify/single/", {
      account_id: accountId,
      ...(personId ? { person_id: personId } : {}),
      ...(email ? { email } : {}),
    });
    return res.data;
  },

  verifyBulk: async ({ accountId, personIds }) => {
    const res = await api.post("/api/validation/verify/bulk/", {
      account_id: accountId,
      person_ids: personIds,
    });
    return res.data;
  },

  listVerificationTasks: async (accountId) => {
    const res = await api.get("/api/validation/verify/bulk/list/", {
      params: { account_id: accountId },
    });
    return Array.isArray(res.data) ? res.data : [];
  },

  getVerificationTask: async (taskId) => {
    const res = await api.get(`/api/validation/verify/bulk/${taskId}/`);
    return res.data;
  },

  downloadTemplate: async () => {
    const res = await api.get("/api/validation/templates/csv/", {
      responseType: "blob",
    });
    const url = window.URL.createObjectURL(new Blob([res.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "validation_template.csv");
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  },
};
